import React from 'react'
import Button from '../../../components/base/Button'
import { postData } from '../../../services/FetchNodeServices';

const FilteredOrdersCom = ({ setFilters, filters, setFilteredOrders, orders, setOrders, totalPages, currentPage, setTotalPages, fetchAllOrder, setCurrentPage, setIsLoadingOrders }) => {

  const applyFilters = async () => {
    if (setIsLoadingOrders) setIsLoadingOrders(true);
    try {
      if (currentPage !== 1) {
        setCurrentPage(1); // Changing currentPage will automatically trigger fetchAllOrder via useEffect
      } else {
        await fetchAllOrder(); // Explicitly call if already on page 1
      }
    } catch (error) {
      console.log(error)
    } finally {
      if (setIsLoadingOrders) setIsLoadingOrders(false);
    }
  }

  const clearFilters = () => {
    setFilters({
      search: '',
      status: '',
      orderType: '',
      paymentType: '',
      dateFrom: '',
      dateTo: '',
    });
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      setTimeout(() => fetchAllOrder(), 0); // Wait for state to settle then fetch
    }
  }

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-4">

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
          <input
            type="text"
            placeholder="Order number, customer..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
          <div className="relative">
            <select
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
              className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none"
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Packed">Packed</option>
              <option value="Shipped">Shipped</option>
              <option value="Delivered">Delivered</option>
              <option value="Cancelled">Cancelled</option>
            </select>
            <i className="ri-arrow-down-s-line absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Order Type</label>
          <div className="relative">
            <select
              value={filters.orderType}
              onChange={(e) => setFilters({ ...filters, orderType: e.target.value })}
              className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none"
            >
              <option value="">All Types</option>
              <option value="Online">Online</option>
              <option value="Offline">Offline</option>
            </select>
            <i className="ri-arrow-down-s-line absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Payment</label>
          <div className="relative">
            <select
              value={filters.paymentType}
              onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
              className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none"
            >
              <option value="">All Payments</option>
              <option value="Complete Payment">Complete Payment</option>
              <option value="Partial Payment">Partial Payment</option>
            </select>
            <i className="ri-arrow-down-s-line absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
          <input
            type="date"
            value={filters.dateFrom || ''}
            onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
          <input
            type="date"
            value={filters.dateTo || ''}
            onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
        </div>

        <div className="flex items-end gap-2">
          <Button
            onClick={applyFilters}
            className="flex-1 bg-blue-600 text-white hover:bg-blue-700"
          >
            Apply
          </Button>
          <Button
            onClick={clearFilters}
            className="flex-1 bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            Clear
          </Button>
        </div>

      </div>
    </div>
  )
}

export default FilteredOrdersCom
